/*
 * @Author: 汪永康 wangyongkang@yxj.org.cn
 * @Date: 2024-08-19 15:21:11
 * @LastEditors: 汪永康 wangyongkang@yxj.org.cn
 * @LastEditTime: 2024-08-24 14:30:11
 * @FilePath: \h5-lcjc-formula\src\utils\category\GIT.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/** 胃肠消化病学 */

/** 对应的标题 */
const categoryMap = {
  Eckardt: 'Eckardt 评分',
  HRAR: '高危再酗酒评分',
  Forrest: 'Forrest 分级',
  BalthazarCTModified: 'Balthazar CT 指数（改良版）',
  ChildPugh: 'Child-Pugh 分级',
  HpInfectionEradicationCriteria: '幽门螺旋杆菌（Hp）感染根除标准',
  Hinchey: 'Hinchey分类',
  NonalcoholicFattyLiver: '非酒精性脂肪肝纤维化评分',
  GlasgowBlatchford: 'Glasgow-Blatchford评分',
  Ranson: 'Ranson评分',
  EckardtScore: 'Eckardt评分',
  HarveyBradshawIndex: 'Harvey‑Bradshaw指数',
  CIWAArScore: 'CIWA-Ar评分',
  GlasgowSystem: 'Glasgow胰腺炎评分系统',
  ACCR: '淀粉酶肌酐清除比值',
  CDAI: 'CDAI',
  Colorectal_polyp: '结直肠息肉NICE分类',
  LPS: '脂肪酶',
  Amylase: '淀粉酶'
}
/** 对应的描述 */
const categoryDescMap = {
  Eckardt: '贲门失弛缓症的临床评分系统。',
  HRAR: '肝移植后再酗酒',
  Forrest: '用于上消化道出血',
  BalthazarCTModified: '根据 CT 评估急性胰腺炎',
  ChildPugh: '根据 CT 评估急性胰腺炎',
  HpInfectionEradicationCriteria: '用于判断Hp是否已根除',
  Hinchey: '腹膜炎分类',
  NonalcoholicFattyLiver: '评估非酒精性脂肪肝患者肝纤维化情况',
  GlasgowBlatchford: 'Glasgow-评估急性上消化道出血风险',
  Ranson: '评估急性胰腺炎严重度',
  EckardtScore: '贲门失弛缓症临床症状评分系统',
  HarveyBradshawIndex: 'CADI简化版',
  CIWAArScore: '临床酒精戒断评估标准',
  GlasgowSystem: '评估急性胰腺炎严重度',
  ACCR: '早期诊断胰腺炎',
  CDAI: '克罗恩氏病活动度指数',
  Colorectal_polyp: '判断结直肠肿瘤性及非肿瘤性息肉'
}
export default {
  categoryMap,
  categoryDescMap
}



// WEBPACK FOOTER //
// ./src/utils/category/GIT.js